import * as React from "react";
import classnames from "classnames";
import { Text } from "@grandvisionhq/elements";
/* empty css                   */
const TimeSlotsItem = ({ className, selected, label, onSelect, ...rest }) => /* @__PURE__ */ React.createElement(
  "button",
  {
    ...rest,
    className: classnames("time-slots-item", className, {
      "time-slots-item--selected": selected
    }),
    role: "checkbox",
    "aria-checked": selected,
    onClick: onSelect,
    type: "button"
  },
  /* @__PURE__ */ React.createElement(Text, { variant: "body", component: "span" }, label)
);
export {
  TimeSlotsItem as default
};
//# sourceMappingURL=TimeSlotsItem.js.map
